import config from "../config";
import { RecommendationReviewList } from "./constants";

export const getCountry = (data: any) => {
    return data.address_components.find((ac: any) => ac.types.indexOf("country") !== -1)
}



export const getLocation = (data: any) => {
    let locality = null;
    let administrative_area_level_2 = null;
    let administrative_area_level_1 = null;
    let country = null;

    data.address_components.forEach((component: any) => {
        if (component.types.includes("locality")) {
            locality = component.long_name;
        } else if (component.types.includes("administrative_area_level_2")) {
            administrative_area_level_2 = component.long_name;
        } else if (component.types.includes("administrative_area_level_1")) {
            administrative_area_level_1 = component.long_name;
        } else if (component.types.includes("country")) {
            country = component.long_name;
        }
    });
    return locality || administrative_area_level_2 || administrative_area_level_1 || country;
}

export const sendXhrCall = async(url: string, method: "get"| "post", body? : any) => {
    const response = await fetch(`${config.apigateway.url}${url}`, {
        method: method,
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json'
        }
    })
    return await response.json()	
}

export const getRecommendationReviewChipTitle = (review: any) => {
    switch(review) {
      case 0 : return RecommendationReviewList.BAD
      case 2 : return RecommendationReviewList.LOVED
      default : 
        return RecommendationReviewList.LIKED
    }
  }

  
  export const getCity = (data: any) => {
    return data.address_components.find((ac: any) => ac.types.indexOf("locality") !== -1)
  }
  
